import React, { useState } from 'react';
import { Mail, MapPin, Send, Loader2, Check } from 'lucide-react';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setTimeout(() => { setSending(false); setSent(true); setForm({ name: '', email: '', subject: '', message: '' }); }, 1500);
  };

  return (
    <div>
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-14">
            <span className="font-label text-[var(--color-coral)] mb-3 inline-block">CONTACT</span>
            <h1 className="font-serif text-4xl md:text-5xl mb-4">Get in touch</h1>
            <p className="text-base text-[var(--color-muted)]">We'd love to hear from you. Fill out the form or reach us directly.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="md:col-span-2">
              {sent ? (
                <div className="card p-14 text-center">
                  <div className="w-14 h-14 mx-auto rounded-full flex items-center justify-center mb-4 bg-green-50">
                    <Check className="w-7 h-7 text-green-600" />
                  </div>
                  <h3 className="font-display text-base font-medium mb-2">Message sent!</h3>
                  <p className="text-sm text-[var(--color-muted)]">We'll get back to you within 24 hours.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="card p-6 space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-medium mb-1.5">Name *</label>
                      <input type="text" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})}
                        className="input" placeholder="Your name" required data-testid="contact-name" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium mb-1.5">Email *</label>
                      <input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}
                        className="input" placeholder="you@example.com" required data-testid="contact-email" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-medium mb-1.5">Subject</label>
                    <select value={form.subject} onChange={(e) => setForm({...form, subject: e.target.value})} className="input">
                      <option value="">Select a topic</option>
                      <option value="general">General Inquiry</option>
                      <option value="support">Technical Support</option>
                      <option value="enterprise">Enterprise Sales</option>
                      <option value="partnership">Partnership</option>
                      <option value="press">Press & Media</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-medium mb-1.5">Message *</label>
                    <textarea value={form.message} onChange={(e) => setForm({...form, message: e.target.value})}
                      className="input min-h-[140px] resize-y" placeholder="How can we help?" required data-testid="contact-message" />
                  </div>
                  <button type="submit" disabled={sending} className="btn btn-primary" data-testid="contact-submit">
                    {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4" /> Send message</>}
                  </button>
                </form>
              )}
            </div>

            <div className="space-y-5">
              <div className="card p-6">
                <Mail className="w-5 h-5 text-[var(--color-coral)] mb-3" />
                <h3 className="font-display text-sm font-medium mb-1">Email</h3>
                <p className="text-xs text-[var(--color-muted)]">hello@stilos.my</p>
                <p className="text-xs text-[var(--color-muted)]">support@stilos.my</p>
              </div>
              <div className="card p-6">
                <MapPin className="w-5 h-5 text-[var(--color-coral)] mb-3" />
                <h3 className="font-display text-sm font-medium mb-1">Location</h3>
                <p className="text-xs text-[var(--color-muted)]">European Union</p>
                <p className="text-xs text-[var(--color-muted)]">GDPR Compliant</p>
              </div>
              <div className="card p-6 bg-[var(--color-surface)]" style={{boxShadow: 'none'}}>
                <h3 className="font-display text-xs font-medium mb-2">Response times</h3>
                <div className="space-y-1 text-xs text-[var(--color-muted)]">
                  <p>Free: 48 hours</p>
                  <p>Starter: 24 hours</p>
                  <p>Pro: 12 hours (priority)</p>
                  <p>Enterprise: Dedicated support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
